import API from '../api';
import { getCateringDraftOrderStatus } from './OrderHelper';

// Dispatches edit to the correct API based on order type.
export async function dispatchOrderEdit(order, fieldsToEdit) {
  const { isCateringDraft } = getCateringDraftOrderStatus(order);
  return isCateringDraft
    ? API.editCateringDraftOrder(order, fieldsToEdit)
    : API.modifyOrder(order, fieldsToEdit);
}
